var _rect, _rect2, _path, _path2, _rect3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCreditCard = function SvgEmptyCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 119,
    viewBox: "0 0 190 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 190,
    height: 119,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 185,
    height: 114,
    rx: 20,
    stroke: "#9A9A99",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 23L183 23",
    stroke: "#9A9A99",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 42L183 42",
    stroke: "#9A9A99",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 60,
    width: 147,
    height: 7,
    stroke: "#9A9A99",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 94,
    r: 13,
    stroke: "#9A9A99",
    strokeWidth: 2,
    strokeDasharray: "2 2"
  })));
};
export default SvgEmptyCreditCard;